import { Expose, Type } from '@nts/std/serialization';
import { EnumDataItem } from './enum-data-item';
import { FieldMetaData } from './field-meta-data';
import { FieldTypes, SimpleFieldType } from '@nts/std/types';
import type { DateTimeMetaDataInterface, EnumDataItemInterface, EnumMetaDataInterface, NumericMetaDataInterface, SimpleFieldMetaDataInterface, StringMetaDataInterface } from '@nts/std/interfaces';
import { NumericMetaData } from '../meta-data/numeric-meta-data';
import { StringMetaData } from '../meta-data/string-meta-data';
import { EnumMetaData } from '../meta-data/enum-meta-data';
import { DateTimeMetaData } from '../meta-data/date-time-meta-data';

export class SimpleFieldMetaData extends FieldMetaData implements SimpleFieldMetaDataInterface {

    constructor() {
        super();
        this.enumData = [];
    }

    @Expose()
    isMultiLine: boolean;

    @Expose()
    defaultValue?: string;

    @Expose()
    primitiveType?: SimpleFieldType;

    @Expose()
    @Type(() => EnumDataItem)
    enumData: EnumDataItemInterface[];

    getFieldType(): FieldTypes {
        return FieldTypes.Simple;
    }

    @Expose()
    @Type(() => NumericMetaData)
    numericMetaData: NumericMetaDataInterface;

    @Expose()
    @Type(() => StringMetaData)
    stringMetaData: StringMetaDataInterface;

    @Expose()
    @Type(() => EnumMetaData)
    enumMetaData: EnumMetaDataInterface<string | number>;

    @Expose()
    @Type(() => DateTimeMetaData)
    dateTimeMetaData: DateTimeMetaDataInterface;
}
